import { pick } from 'lodash'

const transformToUpdateAwardSimpleDetailsArgs = data =>
  pick(data, ['description', 'position'])

export default transformToUpdateAwardSimpleDetailsArgs
